import { render, staticRenderFns } from "./profileHeader.vue?vue&type=template&id=59404b08&scoped=true"
import script from "./profileHeader.vue?vue&type=script&lang=js"
export * from "./profileHeader.vue?vue&type=script&lang=js"
import style0 from "./profileHeader.vue?vue&type=style&index=0&id=59404b08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59404b08",
  null
  
)

export default component.exports